import React from "react";
import { Button } from "../../../common/components/Button";
import logo from "../../../assets/images/hdb-img.png";
import styles from "./index.module.scss";
import { ProgramDetails } from "../../../pages/Registration";
import {
  getCurrentWaitingHeader,
  userRegistration,
} from "../../../utils/registrationUtils";
import { WAIT_LIST } from "../../../constants";
import MahatriaLogo from "../../../assets/images/act-mahatria-logo.svg";
interface PaymentInfo {
  invoiceName?: string;
  amount?: number;
}

interface AwaitingApprovalScreenProps {
  event: ProgramDetails | null;
  userStatus: userRegistration | null;
  paymentInfo?: PaymentInfo;
  onBack: () => void;
  onEditInfo: () => void;
  editRegistration: boolean;
}

const AwaitingApprovalScreen: React.FC<AwaitingApprovalScreenProps> = ({
  userStatus,
  event,
  onBack,
  onEditInfo,
  editRegistration,
}) => {
  const { title, description } = getCurrentWaitingHeader(
    userStatus,
    editRegistration,
  );
  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.programDetails}>
            <div className={styles.logo}>
              <img
                className={styles.logoImage}
                src={MahatriaLogo}
                alt="Mahatria Logo"
              />
            </div>
            <div className={styles.programName}>{userStatus?.program?.name}</div>
          </div>
          <p className={styles.description}>
            <div>Thanks for completing your registration.</div>
            <span>Your request has now been placed with </span>
            <span className={styles.highlight}>Mahatria.</span>
            <span>&nbsp;&nbsp;You can edit your registration details and program choice until you are blessed with a seat.</span>
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <div>
          <Button
            className={styles.cancelButton}
            onClick={() => onBack()}
            buttonClassName={styles.cancelButton}
            buttonTextClassName={styles.cancelText}
          >
          home
          </Button>
        </div>
        <div>
             <Button
              className={styles.cancelButton}
                buttonClassName={styles.cancelButton}
                buttonTextClassName={styles.cancelText}
                onClick={() => onEditInfo()}
              >
                edit form
              </Button>
        </div>
        </div>
      </div>
    </div>
    // <div className={styles.container}>
    //   <div className={styles.content}>
    //     <div className={styles.card}>
    //       <div className={styles.registrationSuccessHeader}>
    //         <img src={logo} />
    //       </div>
    //       <div className={styles.cardContent}>
    //         <div className={styles.successSection}>
    //           {!(userStatus?.registrationStatus === WAIT_LIST) ? (
    //             <p className={styles.regDescription}>
    //               {description.split("Mahatria").map((part, i, arr) =>
    //                 i < arr.length - 1 ? (
    //                   <React.Fragment key={i}>
    //                     {part}
    //                     <span className={styles.highlight}>Mahatria</span>
    //                     <span>.</span>
    //                   </React.Fragment>
    //                 ) : (
    //                   part
    //                 ),
    //               )}
    //             </p>
    //           ) : (
    //             <p className={styles.regDescription}>
    //               Your registration {userStatus?.registrationSeqNumber} for{" "}
    //               {event?.name} has been submitted. All seats are currently
    //               filled, and you’ve been added to the waiting list. We’ll
    //               notify you if a spot opens up.
    //             </p>
    //           )}
    //         </div>
    //         <div className={styles.buttonGroup}>
    //           {/* <Button className={styles.calendarButton}>
    //             <span className={styles.calendarButtonText}>Add to Calendar</span>
    //           </Button> */}
    //           {/* <Button
    //             variant="outline"
    //             className={styles.invoiceButton}
    //           >
    //             Download Invoice
    //           </Button> */}
    // {/* <Button variant="outline" className={styles.invoiceButton}>
    //   download invoice
    // </Button> */}
    //           {/* <Button
    //             variant="outline"
    //             className={styles.invoiceButton}

    //           >
    //             new registration
    //           </Button> */}

    //           {/* { <Button
    //             variant="outline"
    //             className={styles.outlinedButton}
    //             onClick={() => onEditInfo()}
    //           >
    //             edit form
    //           </Button>} */}
    //           <MuiButton
    //             onClick={() => onBack()}
    //             buttonClassName={styles.homeButton}
    //           >
    //             go to home
    //           </MuiButton>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default AwaitingApprovalScreen;
